export default __webpack_public_path__ + "static/media/LookoutMap.fae634e5.jpg";